import { SlideAnnotation, UserName } from "pwapi";

export interface PrecomputedDZI {
  pyramid_levels: number;
  tile_size: number;
  overlap: number;
  format: string;
  width: number;
  height: number;
  original_width: number;
  original_height: number;
  offset_width: number;
  offset_height: number;
}

export enum ViewerMode {
  PAN_ZOOM,
  MEASUREMENT,
  PEN_DRAWING,
  TEXT,
  AREA_COUNT,
  ROI,
}

// Parameters needed to size and scale the SVG overlay
export interface ScaleInfo {
  width: number;
  height: number;
  scaleX: number;
  scaleY: number;
  rotation: number;
  wsiWidth: number; // The dimensions of the original WSI are included in the
  wsiHeight: number; // XML response from the DZI server, but aren't used yet
  dziOffsetX: number; // Location of DZI within WSI, needed for placing AI
  dziOffsetY: number; // overlays. Expected to be zero for all newer slides.
}

export interface XYPoint {
  x: number;
  y: number;
}

export enum AnnotationType {
  MEASUREMENT,
  PEN_DRAWING,
  TEXT,
  AREA_COUNT,
  REGION_OF_INTEREST,
}

export interface Annotation {
  id?: number;
  name: string;
  user: UserName;
  created_at: string;
  type: AnnotationType;
}

interface MeasurementFields {
  point1: XYPoint | null;
  point2: XYPoint | null;
  label: string;
}
interface TextFields {
  point: XYPoint | null;
  label: string;
}
interface PenDrawingFields {
  pathInfo: string;
  is_diagnostic: boolean;
}
interface AreaCountFields {
  point: XYPoint | null;
  label: string | null; // This field will hold the count, in digits
}
interface RegionOfInterestFields {
  points: Array<XYPoint>;
  is_diagnostic: boolean;
  lesionLineType: string;
  subtype: string;
  label: string;
}

// NOTE: The annotation actually sent by the server does not match the one in OpenAPI
// We are doing our best here to create types that correctly reflect the responses
export type ServerAnnotation = Omit<
  SlideAnnotation & Annotation & MeasurementFields & TextFields,
  "type"
> & { type: Annotation["type"] };

export type MeasurementAnnotation = Annotation & MeasurementFields;

export type PenDrawingAnnotation = Annotation & PenDrawingFields;

export type TextAnnotation = Annotation & TextFields;

export type AreaCountAnnotation = Annotation & AreaCountFields;

export type RegionOfInterestAnnotation = Annotation & RegionOfInterestFields;
